import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-alert-time',
  templateUrl: './alert-time.component.html',
  styleUrls: ['./alert-time.component.scss']
})
export class AlertTimeComponent   {

  constructor(public dialogRef: MatDialogRef<AlertTimeComponent>,) { }


  save(confirm){
    this.dialogRef.close(confirm);
  }
}
